class UndrUniverseDescent extends HTMLElement {
  connectedCallback() {
    this.motionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.revealItems = [...this.querySelectorAll('[data-universe-reveal]')];
    this.ensureFormDensity();
    this.randomizeForms();

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      this.revealItems.forEach((item) => this.observer.observe(item));
    } else {
      this.revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    if (this.motionAllowed) {
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerleave', this.resetPointer);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeEventListener('pointermove', this.handlePointerMove);
    this.removeEventListener('pointerleave', this.resetPointer);
  }

  handlePointerMove = (event) => {
    const rect = this.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((event.clientY - rect.top) / window.innerHeight - 0.5) * 2;
    this.style.setProperty('--universe-pointer-x', x.toFixed(3));
    this.style.setProperty('--universe-pointer-y', y.toFixed(3));
  };

  resetPointer = () => {
    this.style.setProperty('--universe-pointer-x', 0);
    this.style.setProperty('--universe-pointer-y', 0);
  };

  ensureFormDensity() {
    const field = this.querySelector('.undr-universe-descent__form-field');
    if (!field || field.dataset.dense === 'true') return;

    const originals = [...field.querySelectorAll('.undr-universe-descent__form')];
    [1, 2].forEach((layer) => {
      originals.forEach((form) => {
        const clone = form.cloneNode(true);
        clone.dataset.formLayer = String(layer);
        field.appendChild(clone);
      });
    });
    field.dataset.dense = 'true';
  }

  randomizeForms() {
    if (window.matchMedia('(max-width: 749px)').matches) return;

    const forms = [...this.querySelectorAll('.undr-universe-descent__form')];
    const slots = [];
    const columns = 7;
    const rows = 5;
    for (let row = 0; row < rows; row += 1) {
      for (let column = 0; column < columns; column += 1) {
        slots.push([column * 15 - 5, row * 22 - 5]);
      }
    }

    for (let index = slots.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [slots[index], slots[swapIndex]] = [slots[swapIndex], slots[index]];
    }

    forms.forEach((form, index) => {
      const [slotX, slotY] = slots[index % slots.length];
      form.style.setProperty('--card-x', `${slotX + (Math.random() * 10 - 5)}%`);
      form.style.setProperty('--card-y', `${slotY + (Math.random() * 11 - 5.5)}%`);
      form.style.setProperty('--card-r', `${Math.random() * 20 - 10}deg`);
      form.style.setProperty('--card-z', String(2 + Math.floor(Math.random() * 24)));
      form.style.setProperty('--card-depth', `${Math.floor(Math.random() * 150)}px`);
      form.style.setProperty('--card-size', `${17 + Math.random() * 10}vw`);
      form.style.setProperty('--drift-x', `${Math.random() * 34 - 17}px`);
      form.style.setProperty('--drift-y', `${Math.random() * 30 - 15}px`);
    });
  }
}

if (!customElements.get('undr-universe-descent')) {
  customElements.define('undr-universe-descent', UndrUniverseDescent);
}
